import {
  Body1,
  Display2,
  Grid,
  GridItem,
  Label2,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableRow,
} from '@sainsburys-tech/fable'
import moment from 'moment'
import React from 'react'

import { IBatchItem } from '../../types/IBatchItem'

interface IProps {
  batchItems: IBatchItem[]
  isPizza: boolean
}

const BatchItemTable = (props: IProps) => (
  <>
    <Table
      className='c-hotfood-report-batch-item-desktop'
      testid='report-batch-item-table'
    >
      <TableHeader>
        <TableRow>
          <TableCell className='c-hotfood-report-batch-item-forecasted-column'>
            <Label2>{props.isPizza ? '' : 'Forecasted'}</Label2>
          </TableCell>
          <TableCell className='c-hotfood-report-batch-item-cooked-column'>
            <Label2>Cooked</Label2>
          </TableCell>
          <TableCell>
            <Label2>Product</Label2>
          </TableCell>
          <TableCell className='c-hotfood-report-batch-item-out-of-cabinet-column'>
            <Label2>Out of cabinet</Label2>
          </TableCell>
        </TableRow>
      </TableHeader>
      <TableBody>
        {props.batchItems.map((bi: IBatchItem, i: number) => (
          <TableRow key={i}>
            <TableCell>
              <Body1>{props.isPizza ? '' : bi.calculatedQuantity}</Body1>
            </TableCell>
            <TableCell>
              <Body1>{bi.quantityProduced}</Body1>
            </TableCell>
            <TableCell>
              <Body1>{bi.skuName}</Body1>
            </TableCell>
            <TableCell
              style={{
                color: bi.outOfCabinetOverdueTime
                  ? 'var(--fable-color-text-error)'
                  : 'inherit',
              }}
              data-testid={`outofcabinet-overdue-${i}`}
            >
              <Body1>
                {bi.outOfCabinet &&
                  moment.utc(bi.outOfCabinet).local().format('HH:mm')}
                {bi.outOfCabinetOverdueTime &&
                  ` (${bi.outOfCabinetOverdueTime})`}
              </Body1>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>

    <div className='c-hotfood-report-batch-item-mobile'>
      {props.batchItems.map((bi: IBatchItem, i: number) => (
        <div
          key={i}
          className={`${i % 2 !== 0 ? 'c-hotfood-report-batch-item-alt-row' : ''}`}
        >
          <Grid>
            <GridItem colSpan={12}>
              <Display2 style={{ marginTop: '8px', marginBottom: '8px' }}>
                {bi.skuName}
              </Display2>
            </GridItem>
          </Grid>

          <Grid className='c-hotfood-report-batch-item-subsection'>
            {!props.isPizza && (
              <>
                <GridItem colSpan={7}>
                  <Label2>Forecasted</Label2>
                </GridItem>
                <GridItem colSpan={5}>{bi.calculatedQuantity}</GridItem>
              </>
            )}
            <GridItem colSpan={7}>
              <Label2>Cooked</Label2>
            </GridItem>
            <GridItem colSpan={5}>
              <Body1>{bi.quantityProduced}</Body1>
            </GridItem>
            <GridItem colSpan={7}>
              <Label2>Out of cabinet</Label2>
            </GridItem>
            <GridItem
              style={{
                color: bi.outOfCabinetOverdueTime
                  ? 'var(--fable-color-text-error)'
                  : 'inherit',
              }}
              colSpan={5}
              data-testid={`outofcabinet-overdue-mobile-${i}`}
            >
              <Body1>
                {bi.outOfCabinet &&
                  moment.utc(bi.outOfCabinet).local().format('HH:mm')}
                {bi.outOfCabinetOverdueTime &&
                  ` (${bi.outOfCabinetOverdueTime})`}
              </Body1>
            </GridItem>
          </Grid>
        </div>
      ))}
    </div>
  </>
)

export default BatchItemTable
